var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-app-card"},[_c('img',{staticClass:"cover",attrs:{"src":require("@/assets/app-cover.png")}}),_c('div',{staticClass:"detail"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("Untitled")]),_c('i',{staticClass:"el-icon-more"})]),_c('div',{staticClass:"time"},[_vm._v("2024-11-27 12:00")])])])
}]

export { render, staticRenderFns }